/**
 * Ce que la barre d'état doit montrer au-dessus de l'espace parent.
 *
 * Elle ne se peint pas par jetons : `expo-status-bar` ne prend pas une couleur d'encre mais un
 * mot — `dark` pour un contenu foncé (sur un header clair), `light` pour un contenu clair (sur un
 * header nuit). Sans ça, l'heure et les icônes du système restent marine sur `#152452` et
 * disparaissent.
 *
 * Le fond ne vaut que sur Android (iOS n'en a pas) ; c'est celui du header, donc la surface
 * posée du thème. Sur le web, `expo-status-bar` ne fait rien — d'où l'absence de garde ici.
 */
import { useUnistyles } from "react-native-unistyles"

import { useIsDarkTheme } from "../../../../design-system/hooks/useIsDarkTheme"

export type ParentStatusBar = { style: "light" | "dark"; backgroundColor: string }

export function useParentStatusBar(): ParentStatusBar {
    const { theme } = useUnistyles()

    return {
        style: useIsDarkTheme() ? "light" : "dark",
        backgroundColor: theme.colors["surface-raised"],
    }
}
